import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadZonesByCameraListFailed, loadZonesByCameraListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadZonesByCameraList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/zones/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      const body = Array.isArray(data.data) ? data.data : [];
      yield put(loadZonesByCameraListSuccessful(body));
      yield call(resolveActionPromise(action, body));
    } else {
      yield put(loadZonesByCameraListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadZonesByCameraListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
